<template>
  <div class="room-popup" v-if="open">
    <transition name="fade" mode="out-in">
      <div class="backdrop" @click.prevent="removeRoom"></div>
    </transition>

    <transition name="popup" mode="out-in">
      <div class="room-popup-content">
        <div class="room-popup-header">
          <div class="heading">Ruimte definiëren</div>
          <div class="room-info" v-if="localRoom.isSaved">
            <button class="remove-room" @click.prevent="forceDeleteRoom">
              Verwijderen
            </button>
          </div>
          <button class="close" @click.prevent="removeRoom"></button>
        </div>
        <form class="room-popup-body" @submit.prevent="updateRoom">
          <div class="room-selectors">
            <EmatInput
              class="room-input"
              type="text"
              v-model="localRoom.name"
              label="Naam (optioneel)"
            />
            <EmatSelect
              label="Type ruimte"
              v-model="localRoom.roomType"
              :options="roomTypes"
              :has-default-option="true"
              :error="roomErrors.find((error) => error.field === 'roomType')"
            />
            <EmatSelect
              label="Type muren"
              v-model="localRoom.wallType"
              :options="wallTypes"
              :has-default-option="true"
              :error="roomErrors.find((error) => error.field === 'wallType')"
            />
            <div class="room-inputs">
              <EmatInput
                class="room-input"
                type="number"
                v-model="localRoom.squareMeters"
                label="Aantal m²"
                :min="0"
                :max="16777215"
              />
              <EmatInput
                class="room-input"
                type="number"
                v-model="localRoom.ceilingHeightInCm"
                label="Hoogte in cm"
                :min="0"
                :max="16777215"
              />
            </div>
          </div>
          <div class="action-buttons">
            <button class="emat-btn" @click.prevent="removeRoom">
              Annuleer
            </button>
            <button type="submit" class="emat-btn emat-btn-success">
              Opslaan
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import EmatSelect from '@/components/form/EmatSelect.vue';
import { mapGetters, mapState } from 'vuex';
import EmatInput from '@/components/form/EmatInput.vue';

export default {
  name: 'RoomPopup',
  components: { EmatInput, EmatSelect },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    room: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localRoom: {
        id: null,
        name: null,
        roomType: null,
        wallType: null,
        squareMeters: null,
        ceilingHeightInCm: null,
        isSaved: false,
      },
      roomErrors: [],
    };
  },
  computed: {
    ...mapState('build', ['activeRoom', 'rooms']),
    ...mapState('roomOptions', ['roomTypes', 'wallTypes']),
    ...mapGetters('build', ['getActiveRoom']),
  },
  mounted() {
    this.initializeLocalRoom();
  },
  watch: {
    open: 'initializeLocalRoom',
  },
  methods: {
    initializeLocalRoom() {
      this.localRoom = { ...this.room };
    },
    close() {
      this.$emit('close');
    },
    async updateRoom() {
      this.clearErrors();

      const isValid = this.validateRoom();

      if (!isValid) {
        return;
      }

      this.$store.commit('build/updateRoom', {
        ...this.localRoom,
        isSaved: true,
      });

      await this.$store.dispatch('build/makeRoom', this.activeRoom);

      const newRoom = this.getActiveRoom;
      if (newRoom?.id === this.localRoom.id) {
        this.copyNoRoomProductsToRoomAfterSave(newRoom);
      }

      this.close();
    },
    copyNoRoomProductsToRoomAfterSave(room) {
      if (this.localRoom.id !== 1 || room.products.length !== 0) {
        return;
      }

      const noRoomSelection = this.rooms.find((room) => room.id === null);
      if (!noRoomSelection) {
        return;
      }

      room.products = noRoomSelection.products;
      noRoomSelection.products = [];

      if (noRoomSelection.uid) {
        delete noRoomSelection.uid;
      }
    },
    validateRoom() {
      if (
        !this.localRoom.roomType &&
        this.localRoom.roomType !== this.roomTypes[0]
      ) {
        this.roomErrors.push({
          message: 'Kies een type ruimte',
          field: 'roomType',
        });
      }
      if (
        !this.localRoom.wallType &&
        this.localRoom.wallType !== this.wallTypes[0]
      ) {
        this.roomErrors.push({
          message: 'Kies een type muur',
          field: 'wallType',
        });
      }

      return this.roomErrors.length === 0;
    },
    clearErrors() {
      this.roomErrors = [];
    },
    async removeRoom() {
      if (!this.room.isSaved) {
        this.$store.commit('build/removeRoom', this.room.id);
        await this.$store.dispatch('brand-color-selection/getBrandColorTypes');
      }

      this.close();
    },
    async forceDeleteRoom() {
      await this.$store.commit('build/removeRoom', this.room.id);
      await this.$store.dispatch('brand-color-selection/getBrandColorTypes');

      this.close();
    },
  },
};
</script>
